import { render } from "./SymbolicThinking.vue?vue&type=template&id=2fe3bc46"
import script from "./SymbolicThinking.vue?vue&type=script&lang=js"
export * from "./SymbolicThinking.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/mehimself.github.io/mehimself.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__